import { render, staticRenderFns } from "./ScannedItem.vue?vue&type=template&id=2f9789e2&"
import script from "./ScannedItem.vue?vue&type=script&lang=js&"
export * from "./ScannedItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports